/**
 * List of Views Tracked For Notifications
 */

export enum Views {
  Fields = 'Fields',
  Paths = 'Paths',
  CompletedMissions = 'CompletedMissions',
  InProgressMisions = 'InProgressMissions',
  App = 'App'
}
